"use client";

import { Columns3, Download, Filter, Loader2, Pencil, Save, X } from "lucide-react";



import { useSmartTableModelContext } from "./smart-table-model-context";

export function SmartTableToolbar<TData>() {
  const m = useSmartTableModelContext<TData>();
  const { data, filters, presets, activePresetId, onPresetChange, onExport, exportLabel, toolbarActions, enableBulkEdit, onBulkSave, bulkActions, showFilters, setShowFilters, showColumns, setShowColumns, t, Button, Select, bulkEditMode, setBulkEditMode, selectedRowIds, isBulkSaving, handleBulkSave, handleBulkCancel } = m;
  return (
    <>
      <div className="flex flex-wrap items-center gap-2">
        {presets !== undefined && presets.length > 0 && (
          <Select
            size="sm"
            value={activePresetId ?? ""}
            onChange={(v) => onPresetChange?.(v)}
            ariaLabel={t("table.preset.aria.select")}
            className="w-auto min-w-[120px]"
            options={presets.map((p) => ({ value: p.id, label: p.name }))}
          />
        )}
        <Button
          variant="outline"
          size="sm"
          onClick={() => setShowFilters(!showFilters)}
          aria-label={t("table.filters.aria.toggle")}
          aria-expanded={showFilters}
        >
          <Filter className="mr-2 h-4 w-4" />
          {t("table.filters")}
          {filters.length > 0 && (
            <span className="ml-2 rounded-full bg-primary px-2 py-0.5 text-xs text-on-primary">
              {filters.length}
            </span>
          )}
        </Button>
        <Button
          variant="outline"
          size="sm"
          onClick={() => setShowColumns(!showColumns)}
          aria-label={t("table.columns.aria.toggle")}
          aria-expanded={showColumns}
        >
          <Columns3 className="mr-2 h-4 w-4" />
          {t("table.columns")}
        </Button>
        {onExport && (
          <Button
            variant="outline"
            size="sm"
            disabled={data.length === 0}
            onClick={onExport}
            aria-label={t("exportData")}
          >
            <Download className="mr-2 h-4 w-4" />
            {exportLabel ?? t("export")}
          </Button>
        )}
        {enableBulkEdit && onBulkSave && !bulkEditMode && (
          <Button
            variant="outline"
            size="sm"
            onClick={() => setBulkEditMode(true)}
            aria-label={t("table.bulkEdit.aria.enter")}
          >
            <Pencil className="mr-2 h-4 w-4" />
            {t("table.bulkEdit.enter")}
          </Button>
        )}
        {enableBulkEdit && onBulkSave && bulkEditMode && (
          <>
            <Button
              variant="outline"
              size="sm"
              onClick={handleBulkCancel}
              aria-label={t("table.bulkEdit.aria.cancel")}
              disabled={isBulkSaving}
            >
              <X className="mr-2 h-4 w-4" />
              {t("table.bulkEdit.cancel")}
            </Button>
            <Button
              variant="default"
              size="sm"
              onClick={handleBulkSave}
              disabled={selectedRowIds.size === 0 || isBulkSaving}
              aria-label={t("table.bulkEdit.aria.save")}
            >
              {isBulkSaving ? (
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
              ) : (
                <Save className="mr-2 h-4 w-4" />
              )}
              {isBulkSaving
                ? t("table.bulkEdit.saving")
                : t("table.bulkEdit.save")}
            </Button>
            <span className="text-sm text-text-secondary">
              {t("table.bulkEdit.selectedCount", {
                count: selectedRowIds.size,
              })}
            </span>
            {bulkActions && selectedRowIds.size > 0 && bulkActions}
            <Button
              variant="ghost"
              size="sm"
              onClick={handleBulkCancel}
              aria-label={t("table.bulkEdit.aria.exit")}
              disabled={isBulkSaving}
            >
              {t("table.bulkEdit.exit")}
            </Button>
          </>
        )}
        {toolbarActions}
      </div>

    </>  );
}
